import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { retry, map, catchError } from 'rxjs/operators';
import 'rxjs/add/observable/throw';

import { Building } from './building.model';
import { BuildingInterface } from './building.interface';
import { BuildingFactory } from './building.factory';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable()
export class BuildingService {

    constructor(private http: HttpClient, private authService: AuthService, private globalService: GlobalService) { }

    getAll(params: HttpParams): Observable<Array<Building>> {
        // params = params.append('token', localStorage.getItem('token'));
        return this.http
            // tslint:disable-next-line:max-line-length
            .get<BuildingInterface[]>(`${environment.apiUrl}/v${environment.apiVersion}/buildings`, { params, headers: this.authService.headers() })
            .pipe(map(data => data
                .map(item => BuildingFactory.fromObject(item)),
            ), catchError(this.errorHandler));
    }

    getSingle(id: string): Observable<Building> {
        return this.http
            .get<BuildingInterface>(`${environment.apiUrl}/v${environment.apiVersion}/buildings/${id}`, { headers: this.authService.headers() })
            .pipe(map(item => BuildingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    createOrUpdate(buildings: Building): Observable<any> {
        if (buildings.id) {
            return this.http
                .put(`${environment.apiUrl}/v${environment.apiVersion}/buildings/${buildings.id}`, buildings, { responseType: 'text', headers: this.authService.headers() })
                .pipe(
                    map(item => JSON.parse(item)),
                    catchError(this.errorHandler)
                );
        }
        return this.http
            .post(`${environment.apiUrl}/v${environment.apiVersion}/buildings`, buildings, { responseType: 'text', headers: this.authService.headers() })
            .pipe(
                map(item => JSON.parse(item)),
                catchError(this.errorHandler)
            );
    }



    updateOrder(buildingId: string, items: any[]): Observable<any> {

        return this.http
            // tslint:disable-next-line:max-line-length
            .patch(`${environment.apiUrl}/v${environment.apiVersion}/buildings`, { items }, { headers: this.authService.headers() })
            .pipe(map(item => BuildingFactory.fromObject(item)),
                catchError(this.errorHandler)
            );
    }

    remove(id: string): Observable<any> {
        return this.http
            .delete(`${environment.apiUrl}/v${environment.apiVersion}/buildings/${id}`, { headers: this.authService.headers() })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    private errorHandler(error: Error | any): Observable<any> {
        // this.globalService.handleError(error);
        console.error('handleError', error)
        return Observable.throw(error);
    }

    /* getAllSearch(searchTerm: string): Observable<Array<Building>> {
        return this.http
            .get<BuildingInterface[]>(`${this.api}/buildings/search/${searchTerm}`)
            .pipe(
                retry(3),
                map(rawCategories => rawCategories
                    .map(rawBuilding => BuildingFactory.fromObject(rawBuilding)),
                ),
                catchError(this.errorHandler)
            );
    } */
}



// WEBPACK FOOTER //
// ./src/app/settings/buildings/shared/building.service.ts